import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
const OnboardPage = () => {
    const [currentStep, setCurrentStep] = useState(1);
    const [phoneNumber, setPhoneNumber] = useState('');
    const [otp, setOtp] = useState(['', '', '', '', '', '']);
    const [upiId, setUpiId] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleGetOtp = () => {
        if (phoneNumber.length === 10) {
            setIsLoading(true);
            setTimeout(() => {
                setIsLoading(false);
                setCurrentStep(2);
            }, 1500);
        }
    };
    const isMobile = window.innerWidth <= 768;
    const logoStyle = {
        width: isMobile ? "80px" : "140px",
        height: isMobile ? "35px" : "auto",
        cursor: "pointer",
    };


    const handleOtpChange = (index, value) => {
        if (value.length <= 1) {
            const newOtp = [...otp];
            newOtp[index] = value;
            setOtp(newOtp);

            // Auto focus next input
            if (value && index < 5) {
                const nextInput = document.getElementById(`otp-${index + 1}`);
                if (nextInput) nextInput.focus();
            }
        }
    };

    const handleVerifyOtp = () => {
        if (otp.every(digit => digit !== '')) {
            setIsLoading(true);
            setTimeout(() => {
                setIsLoading(false);
                setCurrentStep(3);
            }, 1500);
        }
    };

    const handleGetPaid = () => {
        if (upiId.includes('@')) {
            setIsLoading(true);
            setTimeout(() => {
                setIsLoading(false);
                alert('🎉 Congratulations! ₹10 has been credited to your account!');
                navigate('/');
            }, 2000);
        }
    };

    const progressPercentage = (currentStep / 3) * 100;

    return (
        <div className="min-h-screen bg-gradient-to-br from-amber-600 via-orange-600 to-yellow-500 flex items-center justify-center p-4">
            <div className="w-full max-w-md">
                {/* Header */}
                <div className="text-center mb-8">
                    <h1 className="text-4xl font-bold text-white mb-2 animate-pulse flex items-center justify-center gap-x-4">
                        Welcome to
                        <img
                            src="https://github.com/appversal/filehost/blob/main/download.png?raw=true"
                            style={logoStyle}
                            alt="logo of sitemark"
                        />
                    </h1>
                    <p className="text-white/80 text-2xl font-extrabold">Get <span className="text-green-300">₹10 </span>instantly! 💰</p>
                </div>

                {/* Progress Bar */}
                <div className="mb-8">
                    <div className="flex justify-between items-center mb-2">
                        {[1, 2, 3].map((step) => (
                            <div
                                key={step}
                                className={`w-10 h-10 rounded-full flex items-center justify-center text-white font-semibold transition-all duration-500 ${step <= currentStep
                                    ? 'bg-white/30 scale-110 shadow-lg'
                                    : 'bg-white/10'
                                    }`}
                            >
                                {step < currentStep ? '✓' : step}
                            </div>
                        ))}
                    </div>
                    <div className="w-full bg-white/20 rounded-full h-2">
                        <div
                            className="bg-gradient-to-r from-yellow-400 to-orange-500 h-2 rounded-full transition-all duration-700 ease-out"
                            style={{ width: `${progressPercentage}%` }}
                        ></div>
                    </div>
                </div>

                {/* Main Card */}
                <div className="bg-white/95 backdrop-blur-sm rounded-3xl shadow-2xl overflow-hidden">
                    <div className="relative">
                        {/* Step 1 - Phone Number */}
                        <div
                            className={`p-8 transition-all duration-700 ease-in-out ${currentStep === 1
                                ? 'transform translate-x-0 opacity-100'
                                : 'transform -translate-x-full opacity-0 absolute top-0 w-full'
                                }`}
                        >
                            <div className="text-center mb-6">
                                <h2 className="text-2xl font-bold text-gray-800 mb-2">
                                    Create KoinApp account
                                </h2>
                                <p className="text-gray-600 font-semibold text-md">
                                    Get started in just 3 steps!
                                </p>
                            </div>

                            <div className="space-y-6">
                                <div>
                                    <label className="block text-gray-700 font-medium mb-2">
                                        Phone Number
                                    </label>
                                    <div className="relative">
                                        <input
                                            type="tel"
                                            value={phoneNumber}
                                            onChange={(e) => setPhoneNumber(e.target.value.replace(/\D/g, '').slice(0, 10))}
                                            placeholder="Enter 10-digit mobile number"
                                            className="w-full px-4 py-4 border-2 border-gray-200 rounded-xl focus:border-amber-500 focus:outline-none transition-colors text-lg"
                                            maxLength="10"
                                        />
                                    </div>
                                </div>

                                <button
                                    onClick={handleGetOtp}
                                    disabled={phoneNumber.length !== 10 || isLoading}
                                    className={`w-full py-4 rounded-xl font-semibold text-lg transition-all duration-300 ${phoneNumber.length === 10 && !isLoading
                                        ? 'bg-gradient-to-r from-amber-600 to-orange-600 text-white shadow-lg hover:shadow-xl transform hover:scale-105'
                                        : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                        }`}
                                >
                                    {isLoading ? (
                                        <div className="flex items-center justify-center">
                                            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-white mr-2"></div>
                                            Sending OTP...
                                        </div>
                                    ) : (
                                        'Get OTP'
                                    )}
                                </button>
                            </div>
                        </div>

                        {/* Step 2 - OTP Verification */}
                        <div
                            className={`p-8 transition-all duration-700 ease-in-out ${currentStep === 2
                                ? 'transform translate-x-0 opacity-100'
                                : currentStep > 2
                                    ? 'transform -translate-x-full opacity-0 absolute top-0 w-full'
                                    : 'transform translate-x-full opacity-0 absolute top-0 w-full'
                                }`}
                        >
                            <div className="text-center mb-6">
                                <h2 className="text-2xl font-bold text-gray-800 mb-2">
                                    Enter OTP
                                </h2>
                                <p className="text-gray-600">
                                    We've sent a 6-digit code to +91 {phoneNumber}
                                </p>
                            </div>

                            <div className="space-y-6">
                                <div className="flex justify-center space-x-3">
                                    {otp.map((digit, index) => (
                                        <input
                                            key={index}
                                            id={`otp-${index}`}
                                            type="text"
                                            value={digit}
                                            onChange={(e) => handleOtpChange(index, e.target.value)}
                                            className="w-12 h-12 text-center text-xl font-bold border-2 border-gray-200 rounded-xl focus:border-amber-500 focus:outline-none transition-colors"
                                            maxLength="1"
                                        />
                                    ))}
                                </div>

                                <button
                                    onClick={handleVerifyOtp}
                                    disabled={!otp.every(digit => digit !== '') || isLoading}
                                    className={`w-full py-4 rounded-xl font-semibold text-lg transition-all duration-300 ${otp.every(digit => digit !== '') && !isLoading
                                        ? 'bg-gradient-to-r from-green-500 to-emerald-600 text-white shadow-lg hover:shadow-xl transform hover:scale-105'
                                        : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                        }`}
                                >
                                    {isLoading ? (
                                        <div className="flex items-center justify-center">
                                            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-white mr-2"></div>
                                            Verifying...
                                        </div>
                                    ) : (
                                        'Verify OTP'
                                    )}
                                </button>

                                <p className="text-center text-gray-500 text-sm">
                                    Didn't receive? <span className="text-amber-600 cursor-pointer hover:underline">Resend OTP</span>
                                </p>
                            </div>
                        </div>

                        {/* Step 3 - UPI ID */}
                        <div
                            className={`p-8 transition-all duration-700 ease-in-out ${currentStep === 3
                                ? 'transform translate-x-0 opacity-100'
                                : 'transform translate-x-full opacity-0 absolute top-0 w-full'
                                }`}
                        >
                            <div className="text-center mb-6">
                                <h2 className="text-2xl font-bold text-gray-800 mb-2">
                                    Enter UPI ID
                                </h2>
                                <p className="text-green-600 font-semibold text-lg">
                                    Get your ₹10 instantly! 🚀
                                </p>
                            </div>

                            <div className="space-y-6">
                                <div>
                                    <label className="block text-gray-700 font-medium mb-2">
                                        UPI ID
                                    </label>
                                    <input
                                        type="text"
                                        value={upiId}
                                        onChange={(e) => setUpiId(e.target.value.toLowerCase())}
                                        placeholder="yourname@paytm / @phonepe / @gpay"
                                        className="w-full px-4 py-4 border-2 border-gray-200 rounded-xl focus:border-amber-500 focus:outline-none transition-colors text-lg"
                                    />
                                </div>

                                <button
                                    onClick={handleGetPaid}
                                    disabled={!upiId.includes('@') || isLoading}
                                    className={`w-full py-4 rounded-xl font-semibold text-lg transition-all duration-300 ${upiId.includes('@') && !isLoading
                                        ? 'bg-gradient-to-r from-yellow-500 to-orange-600 text-white shadow-lg hover:shadow-xl transform hover:scale-105'
                                        : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                        }`}
                                >
                                    {isLoading ? (
                                        <div className="flex items-center justify-center">
                                            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-white mr-2"></div>
                                            Processing Payment...
                                        </div>
                                    ) : (
                                        'Get Paid ₹10 Instantly! 💸'
                                    )}
                                </button>

                                <div className="bg-green-50 border border-green-200 rounded-xl p-4">
                                    <div className="flex items-center text-green-700">
                                        <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                        </svg>
                                        <span className="text-sm font-medium">Secure & Instant Payment</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <p className="text-center text-white/70 text-sm mt-6">
                    By continuing, you agree to our Terms & Privacy Policy
                </p>
            </div>
        </div>
    );
};

export default OnboardPage;